import type { TFunction } from "i18next";
import type { QueryClient } from "@tanstack/react-query";
import type { WallPost } from "../../api/content";
import { gcDisplayName } from "../../api/conversations";
import { cachedConversations } from "../../lib/cachedConversations";

/**
 * The wall a post lives on, for the dock's "Wall · {{wall}}" line (#32): a GC wall's name (the caller's, else the
 * one the server sent), a personal wall "{{name}}'s wall"; null when the GC name is unknown.
 */
export function wallNameOf(t: TFunction, post: WallPost, gcName: string | null): string | null {
  if (post.ownerType === "USER") return t("wall_of_user", "{{name}}'s wall", { name: post.author.name });
  return gcName || post.wallName || null;
}

/**
 * A GC's display name (gcDisplayName) from the conversations the app already loaded: street chat's group lists, the
 * conversation list, single fetches. For posts from outside the open GC (Liked, casts); null when it is not there.
 */
export function gcNameFromCache(qc: QueryClient, gcId: number): string | null {
  for (const c of cachedConversations(qc, gcId)) {
    const name = gcDisplayName(c);
    if (name) return name;
  }
  return null;
}
